import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  Row,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomSelect from "../../../../components/Common/CustomSelect";

const OfferTrackerModal = props => {
  const {
    isOpen,
    toggle,
    data,
    addOfferTracker,
    offerId,
    editData,
    permissions,
    updateTrackerOfferProfile,
    handleTableChange,
  } = props;

  const [isFormSubmit, setIsFormSubmit] = useState(null);
  const [platformSelect, setPlatformSelect] = useState(null);

  const trackingPlatform = [
    { label: "ADJUST", value: "adjust" },
    { label: "APPSFLYER", value: "appsflyer" },
  ];

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      trackingPlatform.map(item => {
        if (item.label === editData.tracking_platform) {
          setPlatformSelect(item);
        }
      });
    } else {
      setPlatformSelect("");
    }
  }, [isOpen]);

  const handleValidOrderSubmit = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      const tracker = {
        trackingLink: params["tracking_link"],
        trackingPlatform: platformSelect.label,
        offer: offerId,
      };

      if (editData !== null) {
        updateTrackerOfferProfile(editData.id, tracker, data);
        toggle();
      } else {
        addOfferTracker(tracker, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} tracker
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Tracking link</Label>
                <AvField
                  name="tracking_link"
                  type="url"
                  placeholder="Tracking link..."
                  value={editData?.tracking_link || ""}
                  errorMessage="This value should be a valid url."
                  validate={{
                    required: { value: true },
                  }}
                />
              </div>
              <div className="mb-3">
                <Label>Tracking platform</Label>
                <FormGroup>
                  <CustomSelect
                    name="platform"
                    options={trackingPlatform}
                    placeholder="Select tracking platform..."
                    classNamePrefix="select2-selection"
                    errorMessage="Tracking platform field is required"
                    defaultValue={platformSelect}
                    onChange={setPlatformSelect}
                    required
                    isFormSubmit={isFormSubmit}
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_offertrackermodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

OfferTrackerModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  addOfferTracker: PropTypes.func,
  offerId: PropTypes.any,
  updateTrackerOfferProfile: PropTypes.func,
  editData: PropTypes.object,
  permissions: PropTypes.object,
  handleTableChange: PropTypes.func,
};

export default OfferTrackerModal;
